export const FREQUENCE_RANGE = [0, 20]
